import { defineMessages } from 'react-intl';

const messages = defineMessages({
  trackingPageBackground: {
    description: 'settings.stores.selectedStore.trackingPageBackground',
    defaultMessage: 'Tracking Page Background',
    id: 'EPv0TI',
  },
  expectedDeliveryColor: {
    description: 'settings.stores.selectedStore.expectedDeliveryColor',
    defaultMessage: 'Expected Delivery Date',
    id: 'iPi/FD',
  },
  socialMediaLinksColor: {
    description: 'settings.stores.selectedStore.socialMediaLinksColor',
    defaultMessage: 'Service Menu & Social Media Links',
    id: 'sAz29M',
  },
});

export default messages;
